import { Home, LayoutDashboard, Settings, Shapes, ShieldCheck, ScrollText, Palette } from 'lucide-react'

import { defineArea, defineModule } from '@/lib/module-routes'
import { CAPABILITY_PERMISSIONS, HIERARCHY_PERMISSIONS } from '@/lib/permissions'

import {
  homeRoute,
  entityDashboardRoute,
  entityFeaturesSettingsRoute,
  entitySettingsRoute,
  entityPoliciesRoute,
  entityWhitelabelRoute,
  newPolicyRoute,
} from './routes'
import { adminRoute } from './admin-route'
import { settingsRoute } from './settings-route'
import { hierarchyHomeWidgets } from './home-widgets'

const adminArea = defineArea({ id: 'admin', label: 'Admin sections', product: 'admin', route: adminRoute })

const homeArea = defineArea({ id: 'home', label: 'Home sections', product: 'home' })
const settingsArea = defineArea({
  id: 'settings',
  label: 'Settings sections',
  product: 'admin',
  route: settingsRoute,
})

declare module '@/lib/module-routes' {
  interface Areas {
    admin: typeof adminArea
    home: typeof homeArea
    settings: typeof settingsArea
  }
}

export const hierarchyModule = defineModule({
  widgets: hierarchyHomeWidgets,
  routes: [
    adminRoute,
    homeRoute,
    entityDashboardRoute,
    settingsRoute,
    entitySettingsRoute,
    entityPoliciesRoute,
    entityWhitelabelRoute,
    newPolicyRoute,
    entityFeaturesSettingsRoute,
  ],
  products: [
    {
      id: 'home',
      label: 'Home',
      description: 'Overview and recent activity',
      icon: Home,
      order: 10,
      routes: [entityDashboardRoute],
    },
    {
      id: 'admin',
      label: 'Admin',
      description: 'Access, security, and organization settings',
      icon: ShieldCheck,
      order: 20,
      routes: [adminRoute],
    },
  ],
  areas: [homeArea, adminArea, settingsArea],
  sections: {
    home: [{ id: 'home', label: 'Home', order: 10 }],
    admin: [{ id: 'settings', label: 'Settings', order: 40 }],
  },
  navigation: {
    home: [
      { to: '/$entityId/dashboard', label: 'Dashboard', icon: LayoutDashboard, section: 'home', order: 10 },
    ],
    admin: [
      {
        to: '/$entityId/settings/whitelabel', label: 'Whitelabel', icon: Palette,
        permission: HIERARCHY_PERMISSIONS.read, section: 'settings', order: 23,
      },
      { to: '/$entityId/settings', label: 'General', icon: Settings, section: 'settings', order: 10 },
      {
        to: '/$entityId/settings/features',
        label: 'Features',
        icon: Shapes,
        permission: CAPABILITY_PERMISSIONS.read,
        section: 'settings',
        order: 20,
      },
      {
        to: '/$entityId/settings/policies',
        label: 'Policy',
        icon: ScrollText,
        section: 'settings',
        order: 25,
      },
    ],
  },
})
